export default __webpack_public_path__ + "static/media/T130_RoHS.db7e31ab.pdf";